import type { ReactNode } from 'react';
import { cx } from '../internal/tone';

export interface EmptyStateProps {
  icon?: string;
  title?: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/**
 * Tela vazio.
 *
 * Um vazio sem explicação parece uma avaria. Diz-se sempre o que aconteceu e,
 * quando faz sentido, oferece-se o próximo passo.
 */
export function EmptyState({
  icon = '📭',
  title = 'Sem resultados',
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div className={cx('flos-empty', className)}>
      <span className="flos-empty__icon flos-icon" aria-hidden="true">
        {icon}
      </span>
      <h3 className="flos-empty__title">{title}</h3>
      {description ? <p className="flos-empty__description">{description}</p> : null}
      {action ? <div className="flos-empty__action">{action}</div> : null}
    </div>
  );
}
